
import { sendApi } from ".";
import { T_Inquery } from "../model/InqueryModel";

async function inqueryList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/inquery/list",
      data: {
        ...data,
      },
    });

    return response;
  }

async function inqueryCreate(data1?:T_Inquery){

  console.log("inquerydata:",data1);
  const response = await sendApi({
    method: "post",
    url: "/inquery/insert",
    isForm:true,
    data: {
      ...data1,
    },
  });

  return response;
}  


async function inqueryEdit(data1?:any){

    const response = await sendApi({
      method: "post",
      url: "/inquery/update",
      isForm:true,
      data: {
        ...data1,
      },
    });
  
    return response;
  }  

  async function inqueryDelete(data1?:T_Inquery){

    const response = await sendApi({
      method: "post",
      url: "/inquery/delete",
      data: {
        ...data1,
      },
    });
  
    return response;
  }  


async function inqueryInfo(data1?:T_Inquery){

    const response = await sendApi({
      method: "post",
      url: "/inquery/info",
      data: {
        ...data1,
      },
    });

    return response;
  }  
const inquery = {
    inqueryList,
    inqueryCreate,
    inqueryEdit,
    inqueryInfo,
    inqueryDelete,
  };
  export default inquery;
